import React from 'react';

import { ROLES } from '../domain/constants';
import { creditsPerRemainingSlot, roleCount, rosterOf, sortRoster } from '../domain/team';

// Il muro delle squadre. Due livelli di dettaglio:
// - `summary` mentre si rilancia, quando l'attenzione deve stare sul lotto e
//   qui servono solo crediti e slot;
// - `roster` quando il timer e fermo, cioe' esattamente quando qualcuno vuole
//   controllare chi ha preso chi.
//
// Non riusa TeamColumn: quello rende il nome dentro un <input> e una riga di
// bottoni per ogni giocatore, entrambi senza senso su un proiettore.

export default function TvTeams({ auction, catalogue, detail }) {
    const playersPerTeam = auction.settings?.players_per_team ?? {};
    const leaderId = auction.lot?.leading_participant_id ?? null;

    return (
        <div className={`tv-teams tv-teams--${detail}`}>
            {auction.participants.map((participant) => {
                const team = auction.teams[participant.id];
                const online = auction.online_ids?.includes(participant.id);
                const isTurn = auction.current_turn_participant_id === participant.id;
                const isLeader = leaderId === participant.id;
                const perSlot = creditsPerRemainingSlot(team, playersPerTeam);

                return (
                    <article
                        key={participant.id}
                        className={`tv-team${isTurn ? ' is-current-turn' : ''}${
                            isLeader ? ' is-leader' : ''
                        }`}
                    >
                        <header className="tv-team-head">
                            <span
                                className={`tv-team-dot${online ? '' : ' tv-team-dot--offline'}`}
                                aria-label={online ? 'collegato' : 'non collegato'}
                            />
                            <h3 className="tv-team-name u-truncate">{participant.name}</h3>
                            <span className="tv-team-budget num">{team?.budget ?? 0}</span>
                        </header>

                        <ul className="tv-team-roles">
                            {ROLES.map((role) => (
                                <li key={role} className="tv-team-role" data-role={role}>
                                    {role} {roleCount(team, role)}/{playersPerTeam[role] ?? 0}
                                </li>
                            ))}
                        </ul>

                        {/* Il numero che serve davvero: quanto puo' ancora
                            permettersi in media per ogni slot che gli resta. */}
                        <p className="tv-team-rate num">
                            {perSlot.toFixed(1)} <span className="tv-team-rate-unit">per slot</span>
                        </p>

                        {detail === 'roster' && (
                            <ul className="tv-team-roster">
                                {sortRoster(rosterOf(team)).map((entry) => {
                                    const player = catalogue[entry.player_id];
                                    return (
                                        <li
                                            key={entry.player_id}
                                            className="tv-team-row"
                                            data-role={entry.role}
                                        >
                                            <span className="tv-team-player u-truncate">
                                                {player?.Cognome
                                                    || player?.['Nome Completo']
                                                    || entry.player_id}
                                            </span>
                                            <span className="tv-team-price num">
                                                {entry.purchase_price}
                                            </span>
                                        </li>
                                    );
                                })}
                                {rosterOf(team).length === 0 && (
                                    <li className="tv-team-empty">Rosa vuota</li>
                                )}
                            </ul>
                        )}
                    </article>
                );
            })}
        </div>
    );
}
